import React from "react";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import {useTranslation} from "react-i18next";
import {NodeDataAccessibility, NodeVisibility} from "../../../../model/IHubMinimalNode.d.ts";

const NodeAndDataVisibilitySelect = ({visible, dataAccess, onChange}) => {
  const {t} = useTranslation();

  return (
    <TextField
      select
      label={t("scenes.nodeSettings.fields.nodeAndDataVisibilitySelect.label")}
      value={`${visible}+${dataAccess}`}
      required
      variant="outlined"
      onChange={({target}) => {
        const [visible, dataAccess] = target.value.split("+");
        onChange({
          visible: Number(visible),
          dataAccess: Number(dataAccess)
        });
      }}
      SelectProps={{SelectDisplayProps: {"aria-haspopup": true}}}
    >
      <MenuItem value={`${NodeVisibility.Yes}+${NodeDataAccessibility.All}`}>
        <Tooltip
          title={t("scenes.nodeSettings.fields.nodeAndDataVisibilitySelect.values.public.tooltip")}
          placement="top"
        >
          <span style={{width: "100%"}}>
            {t("scenes.nodeSettings.fields.nodeAndDataVisibilitySelect.values.public.label")}
          </span>
        </Tooltip>
      </MenuItem>
      <MenuItem value={`${NodeVisibility.No}+${NodeDataAccessibility.All}`}>
        <Tooltip
          title={t("scenes.nodeSettings.fields.nodeAndDataVisibilitySelect.values.hidden.tooltip")}
          placement="top"
        >
          <span style={{width: "100%"}}>
            {t("scenes.nodeSettings.fields.nodeAndDataVisibilitySelect.values.hidden.label")}
          </span>
        </Tooltip>
      </MenuItem>
      <MenuItem value={`${NodeVisibility.Profiled}+${NodeDataAccessibility.Profiled}`}>
        <Tooltip
          title={t("scenes.nodeSettings.fields.nodeAndDataVisibilitySelect.values.private.tooltip")}
          placement="top"
        >
          <span style={{width: "100%"}}>
            {t("scenes.nodeSettings.fields.nodeAndDataVisibilitySelect.values.private.label")}
          </span>
        </Tooltip>
      </MenuItem>
      <MenuItem value={`${NodeVisibility.Yes}+${NodeDataAccessibility.Registered}`}>
        <Tooltip
          title={t("scenes.nodeSettings.fields.nodeAndDataVisibilitySelect.values.registeredUsers.tooltip")}
          placement="top"
        >
          <span style={{width: "100%"}}>
            {t("scenes.nodeSettings.fields.nodeAndDataVisibilitySelect.values.registeredUsers.label")}
          </span>
        </Tooltip>
      </MenuItem>
      {/* <MenuItem value={`${NodeVisibility.No}+${NodeDataAccessibility.Profiled}`}>
        <Tooltip
          title={t("scenes.nodeSettings.fields.nodeAndDataVisibilitySelect.values.profiledData.tooltip")}
          placement="top"
        >
          <span style={{width: "100%"}}>
            {t("scenes.nodeSettings.fields.nodeAndDataVisibilitySelect.values.profiledData.label")}
          </span>
        </Tooltip>
      </MenuItem> */}
    </TextField>
  );
};

export default NodeAndDataVisibilitySelect;
